window.BEAEPAGEJS = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-csql0so0section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-csql0so0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-csql0so0');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-csql0so0: ', ex)
      };
    

      try {
        let argid = 'beae-csql0so0section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-csql0so0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-csql0so0');
        args.el = args.els[0];
        ((d) => { window.BeaeSlider&&window.BeaeSlider(d) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-csql0so0: ', ex)
      };
    

      try {
        let argid = 'beae-t8pc36jxbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-t8pc36jx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-t8pc36jx');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(a){extOptions={},console.error(a)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let a=document.querySelector(selector+","+selector.replace("#","."));if(a)return a.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup")return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}),e.preventDefault(),!1;if(data.type==="pages"&&data.lightbox)return window.BeaePopupLibrary.createPopup(data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'"),{id:data.id,...extOptions}),e.preventDefault(),!1}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((o,t)=>{o.forEach(i=>{i.isIntersecting&&(t.unobserve(i.target),i.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-t8pc36jx: ', ex)
      };
    

      try {
        let argid = 'beae-pyyc351pbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pyyc351p',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pyyc351p');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(a){extOptions={},console.error(a)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let a=document.querySelector(selector+","+selector.replace("#","."));if(a)return a.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup")return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}),e.preventDefault(),!1;if(data.type==="pages"&&data.lightbox)return window.BeaePopupLibrary.createPopup(data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'"),{id:data.id,...extOptions}),e.preventDefault(),!1}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((o,t)=>{o.forEach(i=>{i.isIntersecting&&(t.unobserve(i.target),i.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pyyc351p: ', ex)
      };
    

      try {
        let argid = 'beae-4pl2jfgusection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4pl2jfgu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4pl2jfgu');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4pl2jfgu: ', ex)
      };
    

      try {
        let argid = 'beae-ykzs3orjsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ykzs3orj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ykzs3orj');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ykzs3orj: ', ex)
      };
    

      try {
        let argid = 'beae-ykzs3orjsection-featured-collection',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ykzs3orj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ykzs3orj');
        args.el = args.els[0];
        ((a) => { window.BeaeMoneyFormat||(window.BeaeMoneyFormat=a.moneyFormat);let o=a.el.querySelectorAll(".beae-featuted-collection-nav");const t=a.el.querySelectorAll(".beae-feature-collection-tab-content"),i=a.el.querySelector(".beae-featuted-collection-nav.nav-active"),s=a.el.closest(".beae-body--preview");o.forEach((d,r)=>{a.mode.value=="live"&&!i&&(r===0?(d.classList.add("nav-active"),t[r]&&(t[r].style.display="block",t[r].setAttribute("data-active","true"))):(d.classList.remove("nav-active"),t[r]&&(t[r].style.display="none",t[r].setAttribute("data-active","false")))),s||d.addEventListener("click",()=>{o.forEach(m=>{m.classList.remove("nav-active")}),d.classList.add("nav-active");const c=d.getAttribute("data-handle"),l=a.el.querySelectorAll(".viewall-link");l&&l.forEach(m=>{m.setAttribute("href",`/collections/${c}`)});const u=a.el.querySelector(`.beae-feature-collection-tab-content[data-handle="${c}"]`),p=a.el.querySelector('.beae-feature-collection-tab-content[data-active="true"]');if(p){p.setAttribute("data-active","false");const m=n(p);setTimeout(()=>{p.style.display="none",u&&(u.style.display="block"),setTimeout(()=>{u&&u.setAttribute("data-active","true")},50)},m)}else u&&(u.style.display="block"),setTimeout(()=>{u&&u.setAttribute("data-active","true")},50)})});function n(d){const c=window.getComputedStyle(d).getPropertyValue("transition-duration");let l=parseFloat(c)*1e3;return c.includes("s")?l=parseFloat(c)*1e3:l=parseFloat(c),l||0}typeof window.handleSwatchForCardForm=="function"&&window.handleSwatchForCardForm(a),a.mode.value=="builder"&&window.handleEventFormProductCard() })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ykzs3orj: ', ex)
      };
    

      try {
        let argid = 'beae-ykzs3orjsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ykzs3orj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ykzs3orj');
        args.el = args.els[0];
        ((d) => { window.BeaeSlider&&window.BeaeSlider(d) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ykzs3orj: ', ex)
      };
    

      try {
        let argid = 'beae-retax4w3block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-retax4w3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-retax4w3');
        args.el = args.els[0];
        ((V) => { if(V.el){let N,E=V.autoHover;var P=V.el.querySelector(".beae-img-ratio-control"),M=V.el.querySelector(".beae-image-secondary img");if(P&&M){let z=function(q){let F=0,J,L,T;H(),E?V.el.onmouseover=function(Q){R(Q)}:q.onmousedown=function(Q){R(Q)},V.el.onmouseup=function(){G()},q.ontouchstart=function(Q){R(Q)},V.el.ontouchend=function(){G()};function H(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),q.style.left&&(L=parseInt(q.style.left))}function R(Q){check=!1,Q.preventDefault(),Q.clientX?J=Q.clientX:J=Q.touches[0].clientX,F=1,V.el.onmousemove=function(A){I(A)},V.el.ontouchmove=function(A){I(A)}}function G(){F=0,isNaN(T)||(L=T),check=!0}function I(Q){if(F==0||E&&!(Q.target==M||Q.target==V.el.querySelector(".beae-image-secondary")))return!1;T=oe(Q),T<0&&(T=0),T>100&&(T=100),te(T)}function oe(Q){Q=Q.changedTouches?Q.changedTouches[0]:Q;let A;return E?A=Math.round(Q.offsetX*100/N):A=Math.round(L-(J-Q.pageX)*100/N),A}function te(Q){q.style.left=Q+"%",M.style.clipPath=`polygon(${Q}% 0%, ${Q}% 100%, 100% 100%, 100% 0)`}};P&&M&&z(P),window.addEventListener("resize",function(){P&&M&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),z(P))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-retax4w3: ', ex)
      };
    

      try {
        let argid = 'beae-djkg3dzzsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-djkg3dzz',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-djkg3dzz');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-djkg3dzz: ', ex)
      };
    

      try {
        let argid = 'beae-gtbkzawjblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-gtbkzawj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-gtbkzawj');
        args.el = args.els[0];
        ((V) => { if(V.el){let N,E=V.autoHover;var P=V.el.querySelector(".beae-img-ratio-control"),M=V.el.querySelector(".beae-image-secondary img");if(P&&M){let z=function(q){let F=0,J,L,T;H(),E?V.el.onmouseover=function(Q){R(Q)}:q.onmousedown=function(Q){R(Q)},V.el.onmouseup=function(){G()},q.ontouchstart=function(Q){R(Q)},V.el.ontouchend=function(){G()};function H(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),q.style.left&&(L=parseInt(q.style.left))}function R(Q){check=!1,Q.preventDefault(),Q.clientX?J=Q.clientX:J=Q.touches[0].clientX,F=1,V.el.onmousemove=function(A){I(A)},V.el.ontouchmove=function(A){I(A)}}function G(){F=0,isNaN(T)||(L=T),check=!0}function I(Q){if(F==0||E&&!(Q.target==M||Q.target==V.el.querySelector(".beae-image-secondary")))return!1;T=oe(Q),T<0&&(T=0),T>100&&(T=100),te(T)}function oe(Q){Q=Q.changedTouches?Q.changedTouches[0]:Q;let A;return E?A=Math.round(Q.offsetX*100/N):A=Math.round(L-(J-Q.pageX)*100/N),A}function te(Q){q.style.left=Q+"%",M.style.clipPath=`polygon(${Q}% 0%, ${Q}% 100%, 100% 100%, 100% 0)`}};P&&M&&z(P),window.addEventListener("resize",function(){P&&M&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),z(P))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-gtbkzawj: ', ex)
      };
    

      try {
        let argid = 'beae-3r7ggqsyblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3r7ggqsy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3r7ggqsy');
        args.el = args.els[0];
        ((V) => { if(V.el){let N,E=V.autoHover;var P=V.el.querySelector(".beae-img-ratio-control"),M=V.el.querySelector(".beae-image-secondary img");if(P&&M){let z=function(q){let F=0,J,L,T;H(),E?V.el.onmouseover=function(Q){R(Q)}:q.onmousedown=function(Q){R(Q)},V.el.onmouseup=function(){G()},q.ontouchstart=function(Q){R(Q)},V.el.ontouchend=function(){G()};function H(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),q.style.left&&(L=parseInt(q.style.left))}function R(Q){check=!1,Q.preventDefault(),Q.clientX?J=Q.clientX:J=Q.touches[0].clientX,F=1,V.el.onmousemove=function(A){I(A)},V.el.ontouchmove=function(A){I(A)}}function G(){F=0,isNaN(T)||(L=T),check=!0}function I(Q){if(F==0||E&&!(Q.target==M||Q.target==V.el.querySelector(".beae-image-secondary")))return!1;T=oe(Q),T<0&&(T=0),T>100&&(T=100),te(T)}function oe(Q){Q=Q.changedTouches?Q.changedTouches[0]:Q;let A;return E?A=Math.round(Q.offsetX*100/N):A=Math.round(L-(J-Q.pageX)*100/N),A}function te(Q){q.style.left=Q+"%",M.style.clipPath=`polygon(${Q}% 0%, ${Q}% 100%, 100% 100%, 100% 0)`}};P&&M&&z(P),window.addEventListener("resize",function(){P&&M&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),z(P))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3r7ggqsy: ', ex)
      };
    

      try {
        let argid = 'beae-kks1dv2rblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-kks1dv2r',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-kks1dv2r');
        args.el = args.els[0];
        ((V) => { if(V.el){let N,E=V.autoHover;var P=V.el.querySelector(".beae-img-ratio-control"),M=V.el.querySelector(".beae-image-secondary img");if(P&&M){let z=function(q){let F=0,J,L,T;H(),E?V.el.onmouseover=function(Q){R(Q)}:q.onmousedown=function(Q){R(Q)},V.el.onmouseup=function(){G()},q.ontouchstart=function(Q){R(Q)},V.el.ontouchend=function(){G()};function H(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),q.style.left&&(L=parseInt(q.style.left))}function R(Q){check=!1,Q.preventDefault(),Q.clientX?J=Q.clientX:J=Q.touches[0].clientX,F=1,V.el.onmousemove=function(A){I(A)},V.el.ontouchmove=function(A){I(A)}}function G(){F=0,isNaN(T)||(L=T),check=!0}function I(Q){if(F==0||E&&!(Q.target==M||Q.target==V.el.querySelector(".beae-image-secondary")))return!1;T=oe(Q),T<0&&(T=0),T>100&&(T=100),te(T)}function oe(Q){Q=Q.changedTouches?Q.changedTouches[0]:Q;let A;return E?A=Math.round(Q.offsetX*100/N):A=Math.round(L-(J-Q.pageX)*100/N),A}function te(Q){q.style.left=Q+"%",M.style.clipPath=`polygon(${Q}% 0%, ${Q}% 100%, 100% 100%, 100% 0)`}};P&&M&&z(P),window.addEventListener("resize",function(){P&&M&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),z(P))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-kks1dv2r: ', ex)
      };
    

      try {
        let argid = 'beae-bb1pbur5block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-bb1pbur5',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-bb1pbur5');
        args.el = args.els[0];
        ((V) => { if(V.el){let N,E=V.autoHover;var P=V.el.querySelector(".beae-img-ratio-control"),M=V.el.querySelector(".beae-image-secondary img");if(P&&M){let z=function(q){let F=0,J,L,T;H(),E?V.el.onmouseover=function(Q){R(Q)}:q.onmousedown=function(Q){R(Q)},V.el.onmouseup=function(){G()},q.ontouchstart=function(Q){R(Q)},V.el.ontouchend=function(){G()};function H(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),q.style.left&&(L=parseInt(q.style.left))}function R(Q){check=!1,Q.preventDefault(),Q.clientX?J=Q.clientX:J=Q.touches[0].clientX,F=1,V.el.onmousemove=function(A){I(A)},V.el.ontouchmove=function(A){I(A)}}function G(){F=0,isNaN(T)||(L=T),check=!0}function I(Q){if(F==0||E&&!(Q.target==M||Q.target==V.el.querySelector(".beae-image-secondary")))return!1;T=oe(Q),T<0&&(T=0),T>100&&(T=100),te(T)}function oe(Q){Q=Q.changedTouches?Q.changedTouches[0]:Q;let A;return E?A=Math.round(Q.offsetX*100/N):A=Math.round(L-(J-Q.pageX)*100/N),A}function te(Q){q.style.left=Q+"%",M.style.clipPath=`polygon(${Q}% 0%, ${Q}% 100%, 100% 100%, 100% 0)`}};P&&M&&z(P),window.addEventListener("resize",function(){P&&M&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),z(P))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-bb1pbur5: ', ex)
      };
    

      try {
        let argid = 'beae-j65blzbublock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-j65blzbu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-j65blzbu');
        args.el = args.els[0];
        ((V) => { if(V.el){let N,E=V.autoHover;var P=V.el.querySelector(".beae-img-ratio-control"),M=V.el.querySelector(".beae-image-secondary img");if(P&&M){let z=function(q){let F=0,J,L,T;H(),E?V.el.onmouseover=function(Q){R(Q)}:q.onmousedown=function(Q){R(Q)},V.el.onmouseup=function(){G()},q.ontouchstart=function(Q){R(Q)},V.el.ontouchend=function(){G()};function H(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),q.style.left&&(L=parseInt(q.style.left))}function R(Q){check=!1,Q.preventDefault(),Q.clientX?J=Q.clientX:J=Q.touches[0].clientX,F=1,V.el.onmousemove=function(A){I(A)},V.el.ontouchmove=function(A){I(A)}}function G(){F=0,isNaN(T)||(L=T),check=!0}function I(Q){if(F==0||E&&!(Q.target==M||Q.target==V.el.querySelector(".beae-image-secondary")))return!1;T=oe(Q),T<0&&(T=0),T>100&&(T=100),te(T)}function oe(Q){Q=Q.changedTouches?Q.changedTouches[0]:Q;let A;return E?A=Math.round(Q.offsetX*100/N):A=Math.round(L-(J-Q.pageX)*100/N),A}function te(Q){q.style.left=Q+"%",M.style.clipPath=`polygon(${Q}% 0%, ${Q}% 100%, 100% 100%, 100% 0)`}};P&&M&&z(P),window.addEventListener("resize",function(){P&&M&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),z(P))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-j65blzbu: ', ex)
      };
    

      try {
        let argid = 'beae-qyod6el1section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qyod6el1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qyod6el1');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qyod6el1: ', ex)
      };
    

      try {
        let argid = 'beae-vnp12tdubutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vnp12tdu',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vnp12tdu');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(a){extOptions={},console.error(a)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let a=document.querySelector(selector+","+selector.replace("#","."));if(a)return a.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup")return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}),e.preventDefault(),!1;if(data.type==="pages"&&data.lightbox)return window.BeaePopupLibrary.createPopup(data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'"),{id:data.id,...extOptions}),e.preventDefault(),!1}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((o,t)=>{o.forEach(i=>{i.isIntersecting&&(t.unobserve(i.target),i.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vnp12tdu: ', ex)
      };
    

      try {
        let argid = 'beae-9xvzzc6sblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9xvzzc6s',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9xvzzc6s');
        args.el = args.els[0];
        ((V) => { if(V.el){let N,E=V.autoHover;var P=V.el.querySelector(".beae-img-ratio-control"),M=V.el.querySelector(".beae-image-secondary img");if(P&&M){let z=function(q){let F=0,J,L,T;H(),E?V.el.onmouseover=function(Q){R(Q)}:q.onmousedown=function(Q){R(Q)},V.el.onmouseup=function(){G()},q.ontouchstart=function(Q){R(Q)},V.el.ontouchend=function(){G()};function H(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),q.style.left&&(L=parseInt(q.style.left))}function R(Q){check=!1,Q.preventDefault(),Q.clientX?J=Q.clientX:J=Q.touches[0].clientX,F=1,V.el.onmousemove=function(A){I(A)},V.el.ontouchmove=function(A){I(A)}}function G(){F=0,isNaN(T)||(L=T),check=!0}function I(Q){if(F==0||E&&!(Q.target==M||Q.target==V.el.querySelector(".beae-image-secondary")))return!1;T=oe(Q),T<0&&(T=0),T>100&&(T=100),te(T)}function oe(Q){Q=Q.changedTouches?Q.changedTouches[0]:Q;let A;return E?A=Math.round(Q.offsetX*100/N):A=Math.round(L-(J-Q.pageX)*100/N),A}function te(Q){q.style.left=Q+"%",M.style.clipPath=`polygon(${Q}% 0%, ${Q}% 100%, 100% 100%, 100% 0)`}};P&&M&&z(P),window.addEventListener("resize",function(){P&&M&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),z(P))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9xvzzc6s: ', ex)
      };
    

      try {
        let argid = 'beae-ltygymsjsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ltygymsj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ltygymsj');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ltygymsj: ', ex)
      };
    

      try {
        let argid = 'beae-4eqoq5s0button-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4eqoq5s0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4eqoq5s0');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(a){extOptions={},console.error(a)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let a=document.querySelector(selector+","+selector.replace("#","."));if(a)return a.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup")return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}),e.preventDefault(),!1;if(data.type==="pages"&&data.lightbox)return window.BeaePopupLibrary.createPopup(data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'"),{id:data.id,...extOptions}),e.preventDefault(),!1}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((o,t)=>{o.forEach(i=>{i.isIntersecting&&(t.unobserve(i.target),i.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4eqoq5s0: ', ex)
      };
    

      try {
        let argid = 'beae-swjz3k5nsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-swjz3k5n',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-swjz3k5n');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-swjz3k5n: ', ex)
      };
    

      try {
        let argid = 'beae-swjz3k5nsection-featured-collection',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-swjz3k5n',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-swjz3k5n');
        args.el = args.els[0];
        ((a) => { window.BeaeMoneyFormat||(window.BeaeMoneyFormat=a.moneyFormat);let o=a.el.querySelectorAll(".beae-featuted-collection-nav");const t=a.el.querySelectorAll(".beae-feature-collection-tab-content"),i=a.el.querySelector(".beae-featuted-collection-nav.nav-active"),s=a.el.closest(".beae-body--preview");o.forEach((d,r)=>{a.mode.value=="live"&&!i&&(r===0?(d.classList.add("nav-active"),t[r]&&(t[r].style.display="block",t[r].setAttribute("data-active","true"))):(d.classList.remove("nav-active"),t[r]&&(t[r].style.display="none",t[r].setAttribute("data-active","false")))),s||d.addEventListener("click",()=>{o.forEach(m=>{m.classList.remove("nav-active")}),d.classList.add("nav-active");const c=d.getAttribute("data-handle"),l=a.el.querySelectorAll(".viewall-link");l&&l.forEach(m=>{m.setAttribute("href",`/collections/${c}`)});const u=a.el.querySelector(`.beae-feature-collection-tab-content[data-handle="${c}"]`),p=a.el.querySelector('.beae-feature-collection-tab-content[data-active="true"]');if(p){p.setAttribute("data-active","false");const m=n(p);setTimeout(()=>{p.style.display="none",u&&(u.style.display="block"),setTimeout(()=>{u&&u.setAttribute("data-active","true")},50)},m)}else u&&(u.style.display="block"),setTimeout(()=>{u&&u.setAttribute("data-active","true")},50)})});function n(d){const c=window.getComputedStyle(d).getPropertyValue("transition-duration");let l=parseFloat(c)*1e3;return c.includes("s")?l=parseFloat(c)*1e3:l=parseFloat(c),l||0}typeof window.handleSwatchForCardForm=="function"&&window.handleSwatchForCardForm(a),a.mode.value=="builder"&&window.handleEventFormProductCard() })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-swjz3k5n: ', ex)
      };
    

      try {
        let argid = 'beae-swjz3k5nsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-swjz3k5n',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-swjz3k5n');
        args.el = args.els[0];
        ((d) => { window.BeaeSlider&&window.BeaeSlider(d) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-swjz3k5n: ', ex)
      };
    

      try {
        let argid = 'beae-3uw26bn8block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3uw26bn8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3uw26bn8');
        args.el = args.els[0];
        ((V) => { if(V.el){let N,E=V.autoHover;var P=V.el.querySelector(".beae-img-ratio-control"),M=V.el.querySelector(".beae-image-secondary img");if(P&&M){let z=function(q){let F=0,J,L,T;H(),E?V.el.onmouseover=function(Q){R(Q)}:q.onmousedown=function(Q){R(Q)},V.el.onmouseup=function(){G()},q.ontouchstart=function(Q){R(Q)},V.el.ontouchend=function(){G()};function H(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),q.style.left&&(L=parseInt(q.style.left))}function R(Q){check=!1,Q.preventDefault(),Q.clientX?J=Q.clientX:J=Q.touches[0].clientX,F=1,V.el.onmousemove=function(A){I(A)},V.el.ontouchmove=function(A){I(A)}}function G(){F=0,isNaN(T)||(L=T),check=!0}function I(Q){if(F==0||E&&!(Q.target==M||Q.target==V.el.querySelector(".beae-image-secondary")))return!1;T=oe(Q),T<0&&(T=0),T>100&&(T=100),te(T)}function oe(Q){Q=Q.changedTouches?Q.changedTouches[0]:Q;let A;return E?A=Math.round(Q.offsetX*100/N):A=Math.round(L-(J-Q.pageX)*100/N),A}function te(Q){q.style.left=Q+"%",M.style.clipPath=`polygon(${Q}% 0%, ${Q}% 100%, 100% 100%, 100% 0)`}};P&&M&&z(P),window.addEventListener("resize",function(){P&&M&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),z(P))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3uw26bn8: ', ex)
      };
    

      try {
        let argid = 'beae-azz0ql3jsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-azz0ql3j',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-azz0ql3j');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-azz0ql3j: ', ex)
      };
    

      try {
        let argid = 'beae-wsw9yk94block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wsw9yk94',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wsw9yk94');
        args.el = args.els[0];
        ((V) => { if(V.el){let N,E=V.autoHover;var P=V.el.querySelector(".beae-img-ratio-control"),M=V.el.querySelector(".beae-image-secondary img");if(P&&M){let z=function(q){let F=0,J,L,T;H(),E?V.el.onmouseover=function(Q){R(Q)}:q.onmousedown=function(Q){R(Q)},V.el.onmouseup=function(){G()},q.ontouchstart=function(Q){R(Q)},V.el.ontouchend=function(){G()};function H(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),q.style.left&&(L=parseInt(q.style.left))}function R(Q){check=!1,Q.preventDefault(),Q.clientX?J=Q.clientX:J=Q.touches[0].clientX,F=1,V.el.onmousemove=function(A){I(A)},V.el.ontouchmove=function(A){I(A)}}function G(){F=0,isNaN(T)||(L=T),check=!0}function I(Q){if(F==0||E&&!(Q.target==M||Q.target==V.el.querySelector(".beae-image-secondary")))return!1;T=oe(Q),T<0&&(T=0),T>100&&(T=100),te(T)}function oe(Q){Q=Q.changedTouches?Q.changedTouches[0]:Q;let A;return E?A=Math.round(Q.offsetX*100/N):A=Math.round(L-(J-Q.pageX)*100/N),A}function te(Q){q.style.left=Q+"%",M.style.clipPath=`polygon(${Q}% 0%, ${Q}% 100%, 100% 100%, 100% 0)`}};P&&M&&z(P),window.addEventListener("resize",function(){P&&M&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),z(P))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wsw9yk94: ', ex)
      };
    

      try {
        let argid = 'beae-vvn9w2jdblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vvn9w2jd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vvn9w2jd');
        args.el = args.els[0];
        ((V) => { if(V.el){let N,E=V.autoHover;var P=V.el.querySelector(".beae-img-ratio-control"),M=V.el.querySelector(".beae-image-secondary img");if(P&&M){let z=function(q){let F=0,J,L,T;H(),E?V.el.onmouseover=function(Q){R(Q)}:q.onmousedown=function(Q){R(Q)},V.el.onmouseup=function(){G()},q.ontouchstart=function(Q){R(Q)},V.el.ontouchend=function(){G()};function H(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),q.style.left&&(L=parseInt(q.style.left))}function R(Q){check=!1,Q.preventDefault(),Q.clientX?J=Q.clientX:J=Q.touches[0].clientX,F=1,V.el.onmousemove=function(A){I(A)},V.el.ontouchmove=function(A){I(A)}}function G(){F=0,isNaN(T)||(L=T),check=!0}function I(Q){if(F==0||E&&!(Q.target==M||Q.target==V.el.querySelector(".beae-image-secondary")))return!1;T=oe(Q),T<0&&(T=0),T>100&&(T=100),te(T)}function oe(Q){Q=Q.changedTouches?Q.changedTouches[0]:Q;let A;return E?A=Math.round(Q.offsetX*100/N):A=Math.round(L-(J-Q.pageX)*100/N),A}function te(Q){q.style.left=Q+"%",M.style.clipPath=`polygon(${Q}% 0%, ${Q}% 100%, 100% 100%, 100% 0)`}};P&&M&&z(P),window.addEventListener("resize",function(){P&&M&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),z(P))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vvn9w2jd: ', ex)
      };
    

      try {
        let argid = 'beae-vwxp9bogbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vwxp9bog',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vwxp9bog');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(a){extOptions={},console.error(a)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let a=document.querySelector(selector+","+selector.replace("#","."));if(a)return a.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup")return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}),e.preventDefault(),!1;if(data.type==="pages"&&data.lightbox)return window.BeaePopupLibrary.createPopup(data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'"),{id:data.id,...extOptions}),e.preventDefault(),!1}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((o,t)=>{o.forEach(i=>{i.isIntersecting&&(t.unobserve(i.target),i.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vwxp9bog: ', ex)
      };
    

      try {
        let argid = 'beae-dqhkbldlbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-dqhkbldl',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-dqhkbldl');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(a){extOptions={},console.error(a)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let a=document.querySelector(selector+","+selector.replace("#","."));if(a)return a.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup")return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}),e.preventDefault(),!1;if(data.type==="pages"&&data.lightbox)return window.BeaePopupLibrary.createPopup(data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'"),{id:data.id,...extOptions}),e.preventDefault(),!1}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((o,t)=>{o.forEach(i=>{i.isIntersecting&&(t.unobserve(i.target),i.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-dqhkbldl: ', ex)
      };
    

      try {
        let argid = 'beae-47s6o8mfsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-47s6o8mf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-47s6o8mf');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-47s6o8mf: ', ex)
      };
    

      try {
        let argid = 'beae-h0gjaqurbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h0gjaqur',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h0gjaqur');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(a){extOptions={},console.error(a)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let a=document.querySelector(selector+","+selector.replace("#","."));if(a)return a.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup")return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}),e.preventDefault(),!1;if(data.type==="pages"&&data.lightbox)return window.BeaePopupLibrary.createPopup(data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'"),{id:data.id,...extOptions}),e.preventDefault(),!1}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((o,t)=>{o.forEach(i=>{i.isIntersecting&&(t.unobserve(i.target),i.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h0gjaqur: ', ex)
      };
    

      try {
        let argid = 'beae-peu43691section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-peu43691',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-peu43691');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-peu43691: ', ex)
      };
    

      try {
        let argid = 'beae-peu43691section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-peu43691',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-peu43691');
        args.el = args.els[0];
        ((d) => { window.BeaeSlider&&window.BeaeSlider(d) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-peu43691: ', ex)
      };
    

      try {
        let argid = 'beae-h044dzvlblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h044dzvl',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h044dzvl');
        args.el = args.els[0];
        ((V) => { if(V.el){let N,E=V.autoHover;var P=V.el.querySelector(".beae-img-ratio-control"),M=V.el.querySelector(".beae-image-secondary img");if(P&&M){let z=function(q){let F=0,J,L,T;H(),E?V.el.onmouseover=function(Q){R(Q)}:q.onmousedown=function(Q){R(Q)},V.el.onmouseup=function(){G()},q.ontouchstart=function(Q){R(Q)},V.el.ontouchend=function(){G()};function H(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),q.style.left&&(L=parseInt(q.style.left))}function R(Q){check=!1,Q.preventDefault(),Q.clientX?J=Q.clientX:J=Q.touches[0].clientX,F=1,V.el.onmousemove=function(A){I(A)},V.el.ontouchmove=function(A){I(A)}}function G(){F=0,isNaN(T)||(L=T),check=!0}function I(Q){if(F==0||E&&!(Q.target==M||Q.target==V.el.querySelector(".beae-image-secondary")))return!1;T=oe(Q),T<0&&(T=0),T>100&&(T=100),te(T)}function oe(Q){Q=Q.changedTouches?Q.changedTouches[0]:Q;let A;return E?A=Math.round(Q.offsetX*100/N):A=Math.round(L-(J-Q.pageX)*100/N),A}function te(Q){q.style.left=Q+"%",M.style.clipPath=`polygon(${Q}% 0%, ${Q}% 100%, 100% 100%, 100% 0)`}};P&&M&&z(P),window.addEventListener("resize",function(){P&&M&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{N=M.offsetWidth})}).observe(M),z(P))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h044dzvl: ', ex)
      };
    

      try {
        let argid = 'beae-2iu95kxcsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2iu95kxc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2iu95kxc');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2iu95kxc: ', ex)
      };
    

      try {
        let argid = 'beae-2iu95kxcsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2iu95kxc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2iu95kxc');
        args.el = args.els[0];
        ((d) => { window.BeaeSlider&&window.BeaeSlider(d) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2iu95kxc: ', ex)
      };
    

      try {
        let argid = 'beae-f11wf3nssection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-f11wf3ns',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-f11wf3ns');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-f11wf3ns: ', ex)
      };
    

      try {
        let argid = 'beae-f11wf3nssection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-f11wf3ns',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-f11wf3ns');
        args.el = args.els[0];
        ((d) => { window.BeaeSlider&&window.BeaeSlider(d) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-f11wf3ns: ', ex)
      };
    }; if (window.BEAEBASE) {window.BEAEPAGEJS()} 